import { DsTagPillVariant } from '@customdesignsystem';

export const STEP_TWO = {
  flowName: 'Suscribir APV',
  back: 'Volver al paso anterior',
  title: 'Paso 2: Régimen y fondo',
  subtitle: 'Tu elección define qué beneficio recibes y cómo se invierte tu ahorro.',
  regimeTitle: '¿En qué régimen quieres ahorrar?',
  regimeSubtitle:
    'Elige un régimen tributario: cada uno da un beneficio distinto',
  regimeLink: 'Conoce las diferencias entre régimen A y B',
  fundTitle: '¿En qué fondo quieres tu ahorro?',
  fundSubtitle:
    'Con la reforma de pensiones (Ley 21.735), el ahorro voluntario se invierte en un fondo generacional por tramo de nacimiento reemplaza a los multifondos A–E que existen hoy para este paso.',
  fundLink: '¿Qué es un fondo generacional?',
  submitButton: 'Continuar',
  editTitle: 'Edita tu régimen y fondo',
  editBack: 'Volver a confirmar la suscripción',
  editSubmit: 'Guardar cambios',
};

export const REGIMES = [
  {
    id: 'A',
    name: 'Régimen A',
    description:
      'El Estado te aportará un 15% extra de lo que ahorres en el año, con un tope de 6 UTM.',
  },
  {
    id: 'B',
    name: 'Régimen B',
    description:
      'Pagarás menos impuestos, porque se rebaja tu base imponible, con un tope de 50 UF mensuales.',
  },
];

export interface IFundOption {
  id: string;
  name: string;
  description?: string;
  risk?: string;
  tone?: string;
}

export const INITIAL_FUND_ID = '1111';

export const GENERATIONAL_FUND_DESCRIPTIONS: Record<string, string> = {
  [INITIAL_FUND_ID]:
    'Prioriza el crecimiento de tu ahorro a largo plazo, con mayor exposición a activos de riesgo.',
};

export const STEP_TWO_MULTI_FUNDS = {
  fundTitle: '¿En qué fondo quieres invertir tu ahorro?',
  fundSubtitle:
    'Puedes invertir tu APV en uno de estos 5 fondos con diferentes tipos de riesgos',
  fundLink: 'Conoce los multifondos',
  rentability: {
    label: 'Rentabilidad',
    period: 'últimos 12 meses',
  },
};

export const MULTI_FUNDS: IFundOption[] = [
  { id: 'A', name: 'Fondo A', risk: 'Más riesgoso', tone: 'red' },
  { id: 'B', name: 'Fondo B', risk: 'Riesgoso', tone: 'orange' },
  { id: 'C', name: 'Fondo C', risk: 'Intermedio', tone: 'green' },
  { id: 'D', name: 'Fondo D', risk: 'Conservador', tone: 'aqua' },
  { id: 'E', name: 'Fondo E', risk: 'Más conservador', tone: 'blue' },
];

export const FUND_TAG_VARIANTS: Record<string, DsTagPillVariant> = {
  red: 'error',
  orange: 'warning',
  green: 'success',
  aqua: 'decorative4',
  blue: 'info',
};
